import { createUseStyles } from "react-jss"
import { titleMarginBottom } from "../constants/layout"
import Button from "../components/Button"
import CardSection from "../components/CardSection"
import DetailsCard from "../components/DetailsCard"
import FullScreenLoadingIndicator from "../components/FullScreenLoadingIndicator"
import useFundingActions from "../hooks/useFundingActions"
import useMarketActions from "../hooks/useMarketActions"
import { useEffect } from "react"
import { useAppSelector } from "../redux/hooks"
import CreditorFundingList from "../components/Funding/CreditorFundingList"

const Funding = () => {
    const styles = useStyles()

    const { 
        getFundingOverview, 
        requestPrefundingTransactionCheck, 
        requestPostfundingTransactionCheck 
    } = useFundingActions()

    const { getMarkets } = useMarketActions()

    const loading = useAppSelector(state => state.funding.loading)
    const fundingOverview = useAppSelector(state => state.funding.fundingOverview)
    const markets = useAppSelector(state => state.market.markets)
    const marketsLoading = useAppSelector(state => state.market.loading)

    useEffect(() => {
        if (markets.length === 0) {
            getMarkets()
        } else {
            getFundingOverview(markets[0].id)
        }
    }, [])

    useEffect(() => {
        if (markets.length > 0 && fundingOverview.length === 0) {
          getFundingOverview(markets[0].id)
        }
    }, [markets])

    const handleCheckPrefundingTransactionsButtonClick = () => {
        requestPrefundingTransactionCheck(markets[0].id) // todo: support selecting which market to sync when more than one market
    }

    const handleCheckPostfundingTransactionsButtonClick = () => {
        requestPostfundingTransactionCheck(markets[0].id) // todo: support selecting which market to sync when more than one market
    }

    return (
    <div className={styles.container}>
       <h1>Funding</h1>
      <div className={styles.actionBar}>
        <Button title='Check for prefunding transactions' onClick={handleCheckPrefundingTransactionsButtonClick} />
        <Button title='Check for postfunding transactions' onClick={handleCheckPostfundingTransactionsButtonClick} />
      </div>
      <CardSection>
        <DetailsCard>
          <h6>Creditors</h6>
          <CreditorFundingList fundingOverview={fundingOverview} />
        </DetailsCard>
      </CardSection>
      <FullScreenLoadingIndicator visible={loading || marketsLoading} />
    </div>
  )
}

export default Funding

const useStyles = createUseStyles({
  container: {
    '& h1': {
      marginBottom: titleMarginBottom
    }
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'left',
    transition: '0.4s'
  },
  idCell: {
    display: 'flex',
    width: 270
  },
  listCell: {
    display: 'flex',
    width: 150
  },
  buttonCell: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end'
  },
  actionBar: {
    display: 'flex',
    marginTop: -40,
    flexDirection: 'row',
    columnGap: 10,
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
})